import { useContextStore } from "@/store/context";

export default defineNuxtPlugin(({ $pinia }) => {

  const contextStore = useContextStore($pinia);
  const router = useRouter();

  router.beforeEach((to, from) => {
    contextStore.setFrom({
      fullPath: from.fullPath,
      path: from.path,
      query: from.query,
      name: from.name,
      params: from.params
    });
  })
  router.afterEach((to, from) => {
    contextStore.setFromUrl(from.fullPath);
  })
})
